module.exports = __webpack_public_path__ + "img/ezzebank-name-color-shadow.047d7ea2.png";